<template>
  <section class="p-2">
    <v-card class="">
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Compliance Values</div>
        <div>
          <bread-crumb
            :bread-crumbs="['Compliance IND', 'Compliance IND Value']"
          />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>

      <!-- <div class="ms-2 mt-1 subtitleFontsize">
        High Profile Parameters setup for Individual Values
      </div> -->
      <v-card-text>
        <v-card-title class="ms-2 mt-0 pa-0">
          <v-row class="">
            <!-- <v-btn
              depressed
              class="me-5"
              small
              color="primary"
              @click="back()"
              outlined
              >Back</v-btn
            > -->

            <v-dialog persistent max-width="400px" v-model="dialog">
              <template>
                <v-row class="mt-0">
                  <v-col cols="12" md="3">
                    <!-- <v-btn
                      depressed
                      color="primary"
                      dark
                      small
                      class="mb-2 text-capitalize"
                      v-bind="attrs"
                      v-on="on"
                      @click="editItem"
                    >
                      <v-icon small class="me-2"
                        >mdi-content-save-plus-outline</v-icon
                      >Add Value
                    </v-btn> -->
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="12" md="4  ">
                    <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Type here to filter the table data."
                      hide-details
                      single-line
                      class="me-4"
                      dense
                      clearable
                    ></v-text-field>
                  </v-col>
                </v-row>
              </template>

              <v-card height="400px">
                <v-form v-model="valid" ref="form">
                  <v-toolbar color="secondary" dark flat dense>
                    <span>{{ formtitle }}</span>
                    <v-spacer></v-spacer>
                    <v-btn depressed icon @click="onClickBack()">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-text class="my-3">
                    <v-row>
                      <v-col>
                        <label class="my-0 rounded labelFontsize required">
                          Values
                        </label>
                        <v-autocomplete
                          dense
                          outlined
                          class="rounded"
                          v-model="complianceDetails.value_type"
                          :items="parametersList"
                          placeholder="Value"
                          :rules="Value"
                        >
                        </v-autocomplete>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col>
                        <label class="my-0 rounded labelFontsize required"
                          >Score</label
                        >
                        <v-autocomplete
                          dense
                          outlined
                          class="rounded"
                          v-model="complianceDetails.risk_score"
                          placeholder="Score"
                          :items="scoreName"
                          :rules="Risk_score"
                        >
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="12">
                        <label
                          class="my-0 rounded labelFontsize"
                          v-if="$route.query.name != 'Customer Type'"
                        >
                          Description
                        </label>
                        <label
                          class="my-0 rounded labelFontsize"
                          v-if="$route.query.name == 'Customer Type'"
                        >
                          Description (Customer Type)
                        </label>
                        <v-text-field
                          placeholder="Description"
                          dense
                          class="rounded"
                          small
                          v-model="complianceDetails.description"
                          outlined
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <div class="d-flex justify-center">
                    <v-btn
                      depressed
                      small
                      color="primary"
                      min-width="170px"
                      @click="postList()"
                      v-if="!complianceDetails.id"
                      class="me-3 mb-5 text-capitalize"
                    >
                      <v-icon small class="me-2"
                        >mdi-content-save-plus-outline</v-icon
                      >Add
                    </v-btn>

                    <v-btn
                      depressed
                      small
                      outlined
                      color="primary"
                      min-width="170px"
                      @click="onClickBack()"
                      v-if="!complianceDetails.id"
                      class="text-capitalize"
                    >
                      <v-icon small class="me-2"
                        >mdi-close-circle-outline</v-icon
                      >Cancel
                    </v-btn>

                    <v-btn
                      depressed
                      small
                      v-if="complianceDetails.id"
                      color="primary"
                      min-width="170px"
                      @click="update()"
                      class="text-capitalize"
                    >
                      <v-icon small class="me-2"
                        >mdi-content-save-edit-outline</v-icon
                      >
                      Update
                    </v-btn>
                    <v-btn
                      depressed
                      small
                      outlined
                      color="primary"
                      min-width="170px"
                      @click="onClickBack()"
                      class="ms-2 text-capitalize"
                      v-if="complianceDetails.id"
                    >
                      <v-icon small class="me-2"
                        >mdi-close-circle-outline</v-icon
                      >Cancel
                    </v-btn>
                  </div>
                </v-form>
              </v-card>
            </v-dialog>
          </v-row>
        </v-card-title>

        <template>
          <label style="font-size: 16px">
            Compliance Parameter:
            <b class="ms-3"
              >{{
                this.riskparameterData &&
                this.riskparameterData.risk_factor &&
                this.riskparameterData.risk_factor.value
              }}{{ " / "
              }}{{
                this.riskparameterData &&
                this.riskparameterData.parameter &&
                this.riskparameterData.parameter.value
              }}</b
            ></label
          >
        </template>
        <v-data-table fixed-header  height="55vh"
          :headers="headers"
          dense
          :items="indvaluecompliance"
          :search="search"
          class="mt-5 p-i"
        >
          <template v-slot:item.is_active="{ item }">
            <v-switch
              v-model="item.is_active"
              height="0px"
              color="success"
              dense
              @change="isactiveupdatecomplivalue(item)"
            ></v-switch>
          </template>
          <template v-slot:item.value_type="{ item }">
            <span>{{ item.value_type ? item.value_type.value : "" }}</span>
          </template>
          <template v-slot:item.risk_score="{ item }">
            <v-select
              v-model="item.risk_score"
              dense
              class="rounded ma-1"
              outlined
              :items="riskScoreWeight"
              hide-details
              type="number"
              hide-spin-buttons
              @input="update(item)"
            ></v-select>
          </template>
          <template v-slot:item.is="{ item }">
            <v-switch v-model="item.is" height="0px" dense></v-switch>
          </template>
          <!-- <template v-slot:item.actions="{ item }">
            <v-icon small color="primary" class="mr-2" @click="editItem(item)">
              mdi-content-save-edit-outline
            </v-icon>
          </template> -->
          <!-- <template v-slot:item.actions="{ item }">
    
              <v-icon small color="green" class="mr-2" @click="editItem(item)">
                md-home
              </v-icon>
    
            </template> -->
        </v-data-table>
        <loading :active="loader" :opacity="0.9" color="#ff6b00" />
      </v-card-text>
    </v-card>
  </section>
</template>
<script>
// import axios from "axios";
import Loading from "vue-loading-overlay";
import alerts from "@/mixins/alerts";
import { complianceINDvalue } from "@/utils/validationCopy.js";
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import commonService from "@/services/CommonService/commonService.js";
import setupService from "@/services/SetupService/setupService.js";
import { filterNumberInput } from "@/utils/contactNumber/formatNumber.js";
export default {
  mixins: [alerts],
  name: "Compliance IND Value",
  data() {
    return {
      ...complianceINDvalue,
      filterNumberInput,
      riskparameterData: null,
      riskScoreWeight: [],
      valid: false,
      dialog: false,
      loader: false,
      mask: ["##", "-", "##"],
      // valid: true,
      // dialogDelete: false,
      is_active: "",
      search: "",
      headers: [
        {
          text: "ID",
          value: "id",
        },
        { text: "Value", value: "value_type" },
        { text: "Score", value: "risk_score", width: "150px" },
        { text: "Description", value: "description" },
        { text: "Active", value: "is_active", sortable: false },
        // { text: "Action", value: "actions", sortable: false, width: 0 },
      ],
      parametersList: [],
      scoreName: [],
      indvaluecompliance: [],
      editedIndex: -1,

      complianceDetails: {
        name: "",
        risk_score: "",
        description: "",
        value_type: "",
      },
      defaultItem: {
        name: "string",
        risk_score: "",
        description: "",
        value_type: "",
      },
    };
  },
  components: {
    BreadCrumb,
    Loading,
  },
  computed: {
    formtitle() {
      return this.editedIndex === -1 ? "Add Category" : "Edit Category";
    },
  },
  mounted() {
    this.riskparameterData = JSON.parse(this.$route.query.data);
    console.log("riskparameterData", this.riskparameterData);
    this.getparameterscorevalue();
    this.getallValueScoresdata();
    if (this.riskparameterData.weight) {
      for (let i = 1; i <= this.riskparameterData.weight; i++) {
        this.riskScoreWeight.push(i.toString());
      }
    }
  },

  watch: {
    dialog(val) {
      val || this.onClickBack();
    },
  },
  methods: {
    async getparameterscorevalue() {
      this.loaderOverlay = true;
      try {
        const response = await commonService.getparameterdropdowns("RPS");
        if (response.data.status_code === 200) {
          this.scoreName = response.data.data.map((i) => {
            return { text: i.value, value: i.value_code };
          });

          // if (this.complianceParaDetails.parameter_type) {
          //   this.getparameterRisk(this.complianceParaDetails.parameter_type);
          // }
        }
        // else if (response.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getparameterscorevalue();
        // }
      } catch (error) {
        console.error(error);
      }
    },
    async getallValueScoresdata() {
      this.loader = true;
      try {
        const response = await setupService.getRiskParameterValue(
          this.riskparameterData.id
        );
        if (response.status === 200) {
          this.loader = false;
          this.indvaluecompliance = response.data.data;
        }
        //  else if (response.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getallValueScoresdata();
        // }
        else {
          this.showAlertError(response.data.message);
          this.loader = false;
        }
        console.log("getallparameters", response);
      } catch (error) {
        this.loader = false;
        this.showAlertError("Something went wrong please try again later.");
        console.error(error);
      }
    },

    async postList() {
      const validate = this.$refs.form.validate();
      if (validate) {
        this.loader = true;
        const postData = {
          parameter_id: this.riskparameterData.id,
          name: this.riskparameterData.parameter.value,
          risk_score: this.complianceDetails.risk_score,
          description: this.complianceDetails.description,
          value_type: this.complianceDetails.value_type,
        };
        try {
          const responseData = await setupService.PostRiskParameterValue(
            postData
          );
          if (responseData && responseData.data.status_code == 200) {
            this.showAlertSuccess(responseData.data.message);
            this.getallValueScoresdata();
            this.onClickBack();
            setTimeout(() => {
              this.loader = false;
            }, 400);
          }
          //  else if (responseData.data.status_code === 401) {
          //   this.returnNewToken();
          //   this.postList();
          // }
          else {
            this.showAlertError(responseData.data.message);
            this.loader = false;
          }
        } catch (error) {
          console.log(error.response);
          this.showAlertError("Something went wrong please try again later.");
          this.loader = false;
        }

        this.onClickBack();
      }
    },
    editItem(item) {
      console.log("item", item);
      this.editedIndex = this.indvaluecompliance.indexOf(item);
      this.complianceDetails = Object.assign({}, item);
      this.complianceDetails.value_type = this.complianceDetails.value_type
        ? item.value_type.value_code
        : "";
      this.dialog = true;
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    async isactiveupdatecomplivalue(isactive) {
      console.log(isactive, "active");
      this.loader = true;
      if (this.editedIndex < -1) {
        Object.assign(
          this.indvaluecompliance[this.editedIndex],
          this.complianceDetails
        );
      } else {
        console.log("prameterdetails ", JSON.stringify(this.complianceDetails));
        try {
          const responseData = await setupService.updateStatusINDValue(
            isactive.id,
            isactive.is_active
          );
          if (responseData && responseData.data.status_code == 200) {
            this.showAlertSuccess(responseData.data.message);
            this.getallValueScoresdata();
          }
          //  else if (responseData.data.status_code === 401) {
          //   this.returnNewToken();
          //   this.isactiveupdatecomplivalue(isactive);
          // }
        } catch (error) {
          this.showAlertError("Something went wrong please try again later.");
          this.loader = false;
          console.log(error);
        }
      }
    },
    async update(item) {
      if (item.risk_score) {
        const payload = {
          parameter_id: this.riskparameterData.id,
          name: item.name,
          risk_score: item.risk_score,
          description: item.description,
          value_type: item.value_type.value_code,
        };

        this.loader = true;

        try {
          const responseData = await setupService.updateINDvalue(
            item.id,
            payload
          );
          if (responseData && responseData.data.status_code == 200) {
            this.showAlertSuccess(responseData.data.message);
            this.getallValueScoresdata();
            this.onClickBack();
            setTimeout(() => {
              this.loader = false;
            }, 400);
          }
          // else if (responseData.data.status_code === 401) {
          //   this.returnNewToken();
          //   this.update();
          // }
        } catch (error) {
          console.log(error);
          this.showAlertError("Something went wrong please try again later.");
        }
      }
    },

    onClickBack() {
      this.dialog = false;
    },
    back() {
      this.$router.push({
        path: "/complianceInd",
      });
    },
  },
};
</script>
<style lang="css">
.required:after {
  content: " *";
  color: red;
}
</style>
